import { anchorLink } from "../include/module";
(() => { anchorLink(); })();

import { mainSlider } from "../include/module";
(() => { mainSlider(); })();

import { headerResize } from "../include/module";
(() => { headerResize(); })();

import { togglePagetop } from "../include/module";
(() => { togglePagetop(); })();

import { toggleMenu } from "../include/module";
(() => { toggleMenu(); })();

import { toggleAccordionYotalog } from "../include/module";
(() => { toggleAccordionYotalog(); })();

$(window).on("load", function() {
  $("body").addClass("loaded");
});



// WEBPACK FOOTER //
// ./src/assets/js/yotalog/script.js